import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBadgesSection from "./components/TrustBadgesSection";
import HouseNumbersSection from "./components/HouseNumbersSection";
import AboutSection from "./components/AboutSection";
import FastProductionSection from "./components/FastProductionSection";
import FastDeliverySection from "./components/FastDeliverySection";
import FeaturesSection from "./components/FeaturesSection";
import VideoSection from "./components/VideoSection";
import ReviewsSection from "./components/ReviewsSection";
import InstallationSection from "./components/InstallationSection";
import ProductsGrid from "./components/ProductsGrid";
import ProcessSection from "./components/ProcessSection";
import GallerySection from "./components/GallerySection";
import FAQSection from "./components/FAQSection";
import BlogSection from "./components/BlogSection";
import NewsletterSection from "./components/NewsletterSection";
import StickyCTA from "./components/StickyCTA";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pb-16">
        <HeroSection />
        <TrustBadgesSection />
        <HouseNumbersSection />
        <AboutSection />
        <FastProductionSection />
        <FastDeliverySection />
        <FeaturesSection />
        <VideoSection />
        <ReviewsSection />
        <InstallationSection />
        <ProductsGrid />
        <ProcessSection />
        <GallerySection />
        <FAQSection />
        <BlogSection />
        <NewsletterSection />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}